import { Button, DialogOverlay, DialogOverlayActions, DialogOverlayFooter, TextArea } from '@fs/zion-ui'
import React, { useContext, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import useNotifications from '../../../hooks/useNotifications'
import { shareReservationsToGroup } from '../../../services/groupsService'
import { GroupContext } from '../GroupContextProvider'

export default function ShareReservationsDialog({ refetchReservations, ...overlay }) {
  const { t } = useTranslation()
  const { error } = useNotifications()
  const { currentGroupData } = useContext(GroupContext)
  const [reservationIds, setReservationIds] = useState()
  const focusElementRef = useRef()

  const confirmBtnOnClick = async () => {
    overlay.close()
    try {
      await shareReservationsToGroup(currentGroupData.id, reservationIds.trim())
      setReservationIds()
      refetchReservations()
    } catch (err) {
      error(
        reservationIds.length > 1
          ? t('groups.errors.sharingReservations', {
              defaultValue: `Error sharing reservations: ${err.message || ''}`,
              message: err.message || '',
            })
          : t('groups.errors.sharingReservation', {
              defaultValue: `Error sharing reservation: ${err.message || ''}`,
              message: err.message || '',
            }),
        err
      )
    }
  }

  const doneBtnOnClick = () => {
    overlay.close()
    setReservationIds()
  }

  return (
    <DialogOverlay
      {...overlay}
      focusRef={focusElementRef}
      title={t('group.reservations.dialogOverlay.share.heading', 'Share Reservations')}
    >
      <TextArea
        ref={focusElementRef}
        label={t('group.reservations.dialogOverlay.share.textAreaLabel', 'Reservation IDs')}
        value={reservationIds}
        onChange={(e) => setReservationIds(e.target.value)}
        disableResize
      />
      <DialogOverlayFooter>
        <DialogOverlayActions>
          <Button emphasis="high" disabled={!reservationIds} onClick={confirmBtnOnClick}>
            {t('action.confirm', 'Confirm')}
          </Button>
          <Button emphasis="medium" onClick={doneBtnOnClick}>
            {t('action.cancel', 'Cancel')}
          </Button>
        </DialogOverlayActions>
      </DialogOverlayFooter>
    </DialogOverlay>
  )
}
